import images from '@assets/images/index'
import { Button } from '@components/ui'
import { Col, Flex, Row, Spin } from 'antd'
import { Draggable, Droppable } from 'react-beautiful-dnd'

import { Entities_Team_MovePlayers_Team } from '@suntex.fim/api-client'

interface TeamListProps {
  Team: Entities_Team_MovePlayers_Team[]
  playerDisplay: boolean
  setSelectedTeam: (team: Entities_Team_MovePlayers_Team) => void
  setPlayerDisplay: (display: boolean) => void
  setContentType?: (contentType: string | undefined) => void
  setTeamInfoModal?: (teamInfoModal: boolean) => void
  setSearchTeamQuery: (searchValue: string) => void
  teamLoading: boolean
  selectedTeamId: number | undefined
}

function TeamList({
  Team,
  playerDisplay,
  setSelectedTeam,
  setPlayerDisplay,
  setContentType,
  setTeamInfoModal,
  setSearchTeamQuery,
  teamLoading,
  selectedTeamId
}: TeamListProps) {
  if (teamLoading) {
    return <Spin />
  }

  const getListStyle = (isDraggingOver: boolean) => ({
    background: isDraggingOver ? 'rgba(63, 178, 255, 0.1)' : '',
    borderColor: isDraggingOver ? '#3FB2FF' : '',
    cursor: 'all-scroll',
    boxShadow: isDraggingOver ? '0px 0px 4px 0px #3fb2ff' : ''
  })
  const getTeamClassName = (team: Entities_Team_MovePlayers_Team) => {
    if (team.teacherName) {
      if (selectedTeamId !== team.id) {
        return 'team-card'
      }
      return 'team-card dragged'
    }
    return 'team-card unassigned'
  }

  return (
    <Row gutter={[16, 16]}>
      {!playerDisplay &&
        Team.map((team, index) => (
          <Droppable
            key={`droppable-${team.id}-${index}`}
            droppableId={String(team.id)}
            mode="virtual"
          >
            {(provided, snapshot) => (
              <Col
                xs={24}
                md={12}
                lg={8}
                key={`col-${team.id}-${index}`}
                ref={provided.innerRef}
                {...provided.droppableProps}
                onClick={() => setSelectedTeam(team)}
              >
                <Draggable
                  key={`draggable-${team.id}-${index}`}
                  draggableId={String(team.id)}
                  index={index}
                >
                  {(draggableProvided) => (
                    <span
                      key={`span-${team.id}-${index}`}
                      ref={draggableProvided.innerRef}
                      {...draggableProvided.draggableProps}
                      {...draggableProvided.dragHandleProps}
                    >
                      <Flex
                        gap="10px"
                        className={getTeamClassName(team)}
                        style={getListStyle(snapshot.isDraggingOver)}
                        vertical
                      >
                        <Flex className="team-card__heading">
                          <h5 className="fw-bold">{team.className || 'NA'}</h5>
                          <span className="text-sm text-chalkboard-txt fw-bold">
                            {team.players?.length}
                          </span>
                        </Flex>
                        <Flex align="center" gap="4px">
                          <span>
                            <images.ProfileCircle />
                          </span>
                          <p className="text-chalkboard-txt">
                            {team.teacherName ? team.teacherName : 'Unknown'}
                          </p>
                        </Flex>
                        <Flex align="center" gap="4px">
                          <span>
                            <images.Teacher />
                          </span>
                          <p className="text-chalkboard-txt">
                            Grade{' '}
                            {team.grade && team.grade > 0
                              ? team.grade
                              : 'Unassigned'}
                          </p>
                        </Flex>
                        <Flex align="center" gap="4px">
                          <span>
                            <images.Courthouse />
                          </span>
                          <p className="text-chalkboard-txt">
                            {team.name && team.name.length > 0
                              ? team.name
                              : 'Unknown'}
                          </p>
                        </Flex>
                        <Flex vertical className="cta-btn">
                          {team.teacherName ? (
                            ''
                          ) : (
                            <span>
                              <Button
                                aria-label="Team information"
                                intent="icon"
                                onClick={() => {
                                  if (setContentType)
                                    setContentType(
                                      team.className?.split(' ')[0]
                                    )
                                  if (setTeamInfoModal) setTeamInfoModal(true)
                                }}
                              >
                                <images.InfoCircle />
                              </Button>
                            </span>
                          )}
                          <Button
                            aria-label="View team details"
                            intent="icon"
                            onClick={() => {
                              setSearchTeamQuery('')
                              setPlayerDisplay(true)
                            }}
                          >
                            <images.LineArrowRight />
                          </Button>
                        </Flex>
                      </Flex>
                    </span>
                  )}
                </Draggable>
                {provided.placeholder}
              </Col>
            )}
          </Droppable>
        ))}
    </Row>
  )
}

export default TeamList
